import { DateTime as u } from "luxon";
import { i18nInstance as s } from "./features/i18n/i18n.js";
function f() {
  return typeof window < "u" && window.document;
}
function g(t, e) {
  return new Promise((n, r) => {
    const i = setTimeout(() => {
      r(new Error("promise timeout"));
    }, t);
    e.then(
      (o) => {
        clearTimeout(i), n(o);
      },
      (o) => {
        clearTimeout(i), r(o);
      }
    );
  });
}
function S(t) {
  return new Promise((e) => {
    setTimeout(e, t);
  });
}
function y(t) {
  return t / 100;
}
function $(t) {
  return Math.ceil(t * 100);
}
function h(t, e) {
  return new Intl.NumberFormat(void 0, {
    style: "currency",
    currency: e
  }).format(t);
}
function p(t) {
  return 0 .toLocaleString(void 0, {
    style: "currency",
    currency: t,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).replace(/\d/g, "").trim();
}
function w(t, e) {
  const n = e ? u.fromJSDate(t).setZone(e) : u.fromJSDate(t), r = n.day.toString().padStart(2, "0"), i = n.month.toString().padStart(2, "0"), o = n.year.toString().slice(-2), a = `${r}/${i}/${o}`, m = n.toLocaleString({
    hour: "2-digit",
    minute: "2-digit"
  });
  return `${a} ${m}`;
}
function D(t) {
  const e = u.fromJSDate(t), n = e.toLocaleString({
    day: "2-digit",
    month: "long"
  }), r = e.toLocaleString({
    hour: "2-digit",
    minute: "2-digit"
  });
  return `${n} ${r}`;
}
function T(t) {
  return t.replace(/[A-Z]/g, (e) => `_${e.toLowerCase()}`);
}
function b(t, e) {
  const n = e ? "$1<br>" : "$1<br>$2";
  return `${t}`.replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, n);
}
function L(t, e, n, r) {
  const i = s.language ?? "en", o = r || void 0, a = typeof t == "number" ? u.fromSeconds(t, {
    locale: i,
    zone: o
  }) : t.setZone(o).setLocale(i), m = u.now().setZone(o).setLocale(i);
  let c = a.toFormat("EEE, dd MMM");
  return a.hasSame(m, "day") && (c = `${e}, ${c}`), a.hasSame(m.plus({ days: 1 }), "day") && (c = `${n}, ${c}`), c;
}
function M(t) {
  return t.set({
    minute: Math.ceil(t.minute / 15) * 15
  });
}
export {
  T as camelToSnakeCase,
  y as centsToNumber,
  L as convertDateToLabel,
  h as formatCurrency,
  p as getCurrencySymbol,
  w as getDateTime,
  D as getDateTimeWithMonthName,
  f as isBrowser,
  M as nearestQuarterHour,
  b as nl2br,
  $ as numberToCents,
  S as sleep,
  g as timeout
};
//# sourceMappingURL=utils.js.map
